import 'jquery'
import '@/sass/lp.css'
import '@/sass/normalize.css'
import '@/pages/lp.js'
